module.exports = __webpack_public_path__ + "img/37.820b0ead.jpg";